import { render, staticRenderFns } from "./CircleCategories.vue?vue&type=template&id=2bd50222&scoped=true&"
import script from "./CircleCategories.vue?vue&type=script&lang=js&"
export * from "./CircleCategories.vue?vue&type=script&lang=js&"
import style0 from "./CircleCategories.vue?vue&type=style&index=0&id=2bd50222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd50222",
  null
  
)

export default component.exports